import React, { useState, useEffect } from 'react';
import { Download, X } from 'lucide-react';
import { Button } from './ui/button';

export default function PWAInstallPrompt() {
  const [deferredPrompt, setDeferredPrompt] = useState(null);
  const [dismissed, setDismissed] = useState(false);

  useEffect(() => {
    const handler = (e) => {
      e.preventDefault();
      setDeferredPrompt(e);
    };
    window.addEventListener('beforeinstallprompt', handler);
    return () => window.removeEventListener('beforeinstallprompt', handler);
  }, []);

  if (!deferredPrompt || dismissed) return null;

  const handleInstall = async () => {
    deferredPrompt.prompt();
    const { outcome } = await deferredPrompt.userChoice;
    if (outcome === 'accepted') {
      setDeferredPrompt(null);
    }
  };

  return (
    <div className="fixed bottom-20 left-4 right-4 sm:left-auto sm:right-4 sm:w-80 bg-white rounded-2xl shadow-2xl border border-gray-100 p-4 z-50 animate-in slide-in-from-bottom-4" data-testid="pwa-install-prompt">
      <div className="flex items-start gap-3">
        <div className="w-10 h-10 rounded-xl bg-gradient-to-r from-blue-600 to-indigo-600 flex items-center justify-center flex-shrink-0">
          <Download className="w-5 h-5 text-white" />
        </div>
        <div className="flex-1">
          <p className="font-semibold text-gray-900 text-sm">Install Wakzy Auto Tech</p>
          <p className="text-xs text-gray-500 mt-0.5">Get the full app experience on your device</p>
          <div className="flex gap-2 mt-3">
            <Button size="sm" onClick={handleInstall} className="rounded-lg bg-gradient-to-r from-blue-600 to-indigo-600 text-white text-xs hover:opacity-90" data-testid="pwa-install-btn">
              Install App
            </Button>
            <Button size="sm" variant="ghost" onClick={() => setDismissed(true)} className="rounded-lg text-xs text-gray-500" data-testid="pwa-dismiss-btn">
              Not now
            </Button>
          </div>
        </div>
        <button onClick={() => setDismissed(true)} className="text-gray-400 hover:text-gray-600">
          <X className="w-4 h-4" />
        </button>
      </div>
    </div>
  );
}
